import React from 'react';
import ReactDOM from 'react-dom';
import './InfoWindow.css';

interface InfoWindowNavigationProps {
  isVisible: boolean;
  width: number;
  onLeftClick: () => void;
  onRightClick: () => void;
  onCloseAllClick: () => void;
  isLeftDisabled: boolean;
  isRightDisabled: boolean;
}

const InfoWindowNavigation: React.FC<InfoWindowNavigationProps> = ({
  isVisible,
  width,
  onLeftClick,
  onRightClick,
  onCloseAllClick,
  isLeftDisabled,
  isRightDisabled,
}) =>
{
  if (!isVisible) return null;

  const isDark = document.documentElement.classList.contains('dark');
  const iconColor = isDark ? '#a79e91' : '#999994';
  const iconDisabledColor = isDark ? '#6e6860' : '#99999459';

  return ReactDOM.createPortal(
    <div className="fake-buttons" style={{ right: 0, width: `${width}px` }}>
      <div className="button-control-infowindow-multiple">
        <div
          className="tool-button enable-help-tooltip"
          ht-name="Left"
          id="left-infowindows"
          onClick={onLeftClick}
        >
          <div className="tool-icon">
            <i
              id="left-infowindows-icon"
              className="material-icons"
              style={{ color: isLeftDisabled ? iconDisabledColor : iconColor }}
            >
              chevron_left
            </i>
          </div>
        </div>
        <div
          className="tool-button enable-help-tooltip"
          ht-name="Right"
          id="right-infowindows"
          onClick={onRightClick}
        >
          <div className="tool-icon">
            <i
              id="right-infowindows-icon"
              className="material-icons"
              style={{ color: isRightDisabled ? iconDisabledColor : iconColor }}
            >
              chevron_right
            </i>
          </div>
        </div>
        <div
          className="tool-button enable-help-tooltip"
          ht-name="Close All Info Windows"
          id="close-infowindows"
          onClick={onCloseAllClick}
        >
          <div className="tool-icon">
            <i className="icon-incorrect-icon"></i>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default InfoWindowNavigation;
